import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../api/axiosInstance';

// Async thunk to fetch notifications list
export const fetchNotifications = createAsyncThunk(
    'notifications/fetchNotifications',
    async ({ filters, token, language }, thunkAPI) => {
        try {
            const response = await axiosInstance.post(
                '/api/Common/GetNotificationsList', filters ,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "lang": language === "English" ? "2" : "1",
                    },
                }
            );
            const { data } = response.data.message; 
            const totalFilteredRecords = response.data.message.filteredRecords;

            // Calculate the max page based on filtered records
            return { data, totalFilteredRecords };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// Async thunk to fetch notification count
export const fetchNotificationCount = createAsyncThunk(
    'notifications/fetchNotificationCount',
    async ({ isRead, token, language }, thunkAPI) => {   
        try {
            const response = await axiosInstance.post(
                '/api/Common/GetNotificationsCount',
                {
                    isRead: isRead
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "lang": language === "English" ? "2" : "1",
                    },
                }
            );
            // console.log("response",response);

            return response.data.message; // Assuming the count is in `message`
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        items: [],
        count: 0, // State to store notification count
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        countStatus: 'idle', // Separate status for count
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch notifications list
            .addCase(fetchNotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            // Fetch notification count
            .addCase(fetchNotificationCount.pending, (state) => {
                state.countStatus = 'loading';
            })
            .addCase(fetchNotificationCount.fulfilled, (state, action) => {
                state.countStatus = 'succeeded';
                state.count = action.payload;
            })
            .addCase(fetchNotificationCount.rejected, (state, action) => {
                state.countStatus = 'failed';
                state.error = action.payload;
            });
    },
});

export default notificationsSlice.reducer;
